import { Injectable } from '@angular/core';
import { GeneralConstants } from '../constants/general.constants';
import { StringBuilder } from '../utils/string-builder.class';
import { environment } from 'src/environments/environment';
import { StorageService } from './storage.service';
import { StorageConstants } from '../constants/storage.constants';
import { NotificationService } from './notification.service';
import { IdentityService } from './identity.service';
import { RestService } from './rest.service';

@Injectable({
  providedIn: 'root'
})
export class LiquidacionService {
  constructor(
    private notificationService: NotificationService,
    private storage: StorageService,
    private rest: RestService,
    private identity: IdentityService
  ) {}

  downloadLiquidacionFile(fechaDesde: Date, FechaHasta?: Date, sucursales?: number[]): Promise<string> {
    const sucursal = sucursales.join(',');
    const request = {
      fechaDesde: this.dateFormatNotHourFrom(fechaDesde),
      fechaHasta: this.dateFormatNotHourTo(FechaHasta),
      cuit: this.identity.getUser().persona.cuilCuit,
      email: this.identity.getUser().email,
      sucursales: sucursal
    };

    return new Promise((resolve, reject) => {
      this.rest
        .post(GeneralConstants.downloadLiquidacionPdf, request)
        .then((response) => {
          resolve(response.message);
        })
        .catch((error) => {
          reject(new Error(error?.message));
        });
    });
  }

  private dateFormatNotHourFrom(value): string {
    if (value) {
      let date = value instanceof Date ? value : new Date(value);
      return `${date.getDate() < 10 ? '0' + date.getDate() : date.getDate()}/${
        date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      }/${date.getFullYear() < 10 ? '0' + date.getFullYear() : date.getFullYear()}`;
    }
  }

  private dateFormatNotHourTo(value): string {
    if (value) {
      let date = value instanceof Date ? value : new Date(value);
      date.setDate(date.getDate());
      const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      const month = date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    }
  }
}
